import React, { useEffect } from 'react';
import { ProcessCatStore } from '../store';
import { useAnyContractListStore } from '@/pages/om/contract/list/store';
import { BlockLoading2, IProcessCtx } from '@/components';
import _ from 'lodash';
import { Alert, message } from 'antd';
import { ContractFormProcess } from '@/pages/om/contract/list/components/form-process';
import { embedProductParamToContract } from '@/pages/om/contract/list/utils';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';

export const ContractFormProxy: React.FC<{
    defaultStore: ProcessCatStore;
    processCtx: IProcessCtx | null;
}> = observer(({ defaultStore, processCtx }) => {
    const [prepared, contractListStore] = useAnyContractListStore({});
    const productHydrationLoading =
        contractListStore.autoFillingLoading ||
        contractListStore.assignProductLoading;
    useEffect(() => {
        if (defaultStore.mutatingDataLoading) {
            defaultStore.setContractProductLoadState('idle');
            return;
        }

        const contract = defaultStore.mutatingData;

        // 故意的副作用，让新表单接管数据
        contractListStore.setMutatingData(contract);
        if (!contract) {
            defaultStore.setContractProductLoadState('idle');
            return;
        }

        contract._contract_attachments = contract.contract_attachments;

        if (!processCtx) {
            defaultStore.setContractProductLoadState('idle');
            return;
        }

        const isCreate = !!processCtx?.definitionId && !processCtx?.instanceId;
        if (isCreate) {
            if (!_.isArray(contract.product)) {
                contract.product = [];
            }
            defaultStore.setContractProductLoadState(
                productHydrationLoading ? 'loading' : 'ready',
            );
            return;
        }

        defaultStore.setContractProductLoadState('loading');

        let active = true;
        const loadProducts = async () => {
            let loaded = false;
            try {
                loaded = await embedProductParamToContract(contract);
            } catch (e) {
                loaded = false;
            }

            // Ignore a late status update after the detail store has moved to
            // another contract or the effect has been disposed.
            if (!active || defaultStore.mutatingData !== contract) {
                return;
            }

            defaultStore.setContractProductLoadState(
                loaded ? 'ready' : 'error',
            );
            if (!loaded) {
                message.error('获取合同产品失败，请刷新后重试');
            }
        };
        loadProducts();

        return () => {
            active = false;
        };
    }, [
        defaultStore.mutatingData,
        defaultStore.mutatingDataLoading,
        processCtx?.definitionId,
        processCtx?.instanceId,
        productHydrationLoading,
    ]);

    // for dep
    const { netValidateResult } = defaultStore;
    useEffect(() => {
        contractListStore.setNetValidateResult(defaultStore.netValidateResult);
    }, [defaultStore.netValidateResult, contractListStore]);

    useEffect(() => {
        if (defaultStore.defaultMeta !== null) {
            contractListStore.setDefaultMeta(defaultStore.defaultMeta);
        }
    }, [defaultStore.defaultMeta]);

    // // 同步这个数据
    // useEffect(() => {
    //     if (defaultStore.defaultMeta) {
    //         defaultStore.defaultMeta.setProcessPermAll(contractListStore.defaultMeta.processPermAll)
    //     }
    // }, [ contractListStore.defaultMeta.processPermAll ])

    if (!prepared || !processCtx) {
        return null;
    }

    if (defaultStore.contractProductLoadState === 'loading') {
        return <BlockLoading2 />;
    }

    if (defaultStore.contractProductLoadState === 'error') {
        return (
            <Alert
                type="error"
                showIcon
                message="获取合同产品失败，请刷新后重试"
            />
        );
    }

    return (
        <ContractFormProcess
            defaultStore={contractListStore}
            processCtx={processCtx}
        />
    );
});
